<template>
  <div class="content">
    <navigation :navName="nav"></navigation>
    <el-form ref="editForm"
             class="mobile-show-box form-wrapper"
             :label-width="formLabelWidth">
      <el-form-item label="栏目名称">
        <el-input placeholder="请输入内容"
                  v-model="name"
                  size="mini"
                  clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="文章管理"
                    v-if="article.length>0">
        <el-select v-model="articleSelected"
                   multiple
                   collapse-tags
                   size='mini'
                   placeholder="请选择"
                   value-key="name"
                   @change="selectArticle">
          <el-option v-for="item in article"
                     :key="item.config"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图片管理"
                    v-if="imgs.length>0">
        <el-select v-model="imgsSelected"
                   multiple
                   collapse-tags
                   size='mini'
                   placeholder="请选择"
                   @change="selectImgs">
          <el-option v-for="item in imgs"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="视频管理"
                    v-if="videos.length>0">
        <el-select v-model="videosSelected"
                   multiple
                   size='mini'
                   collapse-tags
                   placeholder="请选择"
                   @change="selectVideos">
          <el-option v-for="item in videos"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="BANNER"
                    v-if="banner.length>0">
        <el-select v-model="bannerSelected"
                   multiple
                   collapse-tags
                   size='mini'
                   placeholder="请选择"
                   @change="selectBanner">
          <el-option v-for="item in banner"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="其他设置"
                    v-if="settings.length>0">
        <el-select v-model="settingsSelected"
                   multiple
                   collapse-tags
                   size='mini'
                   placeholder="请选择"
                   @change="selectSettings">
          <el-option v-for="item in settings"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="特殊配置"
                    v-if="otherSettings.length>0">
        <el-select v-model="otherSettingsSelected"
                   multiple
                   size='mini'
                   collapse-tags
                   placeholder="请选择"
                   @change="selectOtherSettings">
          <el-option v-for="item in otherSettings"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="已选择配置项"
                    v-if="tags.length>0">
        <el-tag v-for="tag in tags"
                :key="tag.name"
                closable
                :type="tag.config"
                @close="_handleClose(tag)">
          {{tag.name}}
        </el-tag>
      </el-form-item>
      <el-form-item>
        <el-button size="mini"
                   type="primary"
                   @click="addArt()">提交</el-button>
        <el-button size="mini"
                   @click="back()">取消</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-row>
      <el-col :span="4">
        <label>栏目名称</label>
      </el-col>
      <el-col :span="20">
        <el-input placeholder="请输入内容"
                  v-model="name"
                  clearable>
        </el-input>
      </el-col>
    </el-row>
    <el-row v-if="article.length>0">
      <el-col :span="4">
        <label>文章管理</label>
      </el-col>
      <el-col :span="20">
        <el-select v-model="articleSelected"
                   multiple
                   collapse-tags
                   placeholder="请选择"
                   value-key="name"
                   @change="selectArticle">
          <el-option v-for="item in article"
                     :key="item.config"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="imgs.length>0">
      <el-col :span="4">
        <label>图片管理</label>
      </el-col>
      <el-col :span="20">
        <el-select v-model="imgsSelected"
                   multiple
                   collapse-tags
                   placeholder="请选择"
                   @change="selectImgs">
          <el-option v-for="item in imgs"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="videos.length>0">
      <el-col :span="4">
        <label>视频管理</label>
      </el-col>
      <el-col :span="20">
        <el-select v-model="videosSelected"
                   multiple
                   collapse-tags
                   placeholder="请选择"
                   @change="selectVideos">
          <el-option v-for="item in videos"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="banner.length>0">
      <el-col :span="4">
        <label>BANNER</label>
      </el-col>
      <el-col :span="20">
        <el-select v-model="bannerSelected"
                   multiple
                   collapse-tags
                   placeholder="请选择"
                   @change="selectBanner">
          <el-option v-for="item in banner"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="settings.length>0">
      <el-col :span="4">
        <label>其他设置</label>
      </el-col>
      <el-col :span="20">
        <el-select v-model="settingsSelected"
                   multiple
                   collapse-tags
                   placeholder="请选择"
                   @change="selectSettings">
          <el-option v-for="item in settings"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="otherSettings.length>0">
      <el-col :span="4">
        <label>特殊配置</label>
      </el-col>
      <el-col :span="20">
        <el-select v-model="otherSettingsSelected"
                   multiple
                   collapse-tags
                   placeholder="请选择"
                   @change="selectOtherSettings">
          <el-option v-for="item in otherSettings"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="tags.length>0">
      <el-col :span="4">
        <label>已选择配置项</label>
      </el-col>
      <el-col :span="20">
        <el-tag v-for="tag in tags"
                :key="tag.name"
                closable
                :type="tag.config"
                @close="_handleClose(tag)">
          {{tag.name}}
        </el-tag>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="sumbit-btn">
        <el-button type="primary"
                   @click="addArt">提交
        </el-button>
      </el-col>
    </el-row> -->
  </div>
</template>
<style lang="less" scoped>
.el-tag {
  margin-right: 8px;
}
</style>
<script>
import axios from 'axios';
import api from '../../api/api';
import navigation from '../websiteConfig/navigation';


export default {
  data() {
    return {
      configName: '',
      formLabelWidth: '100px',
      name: '',
      tid: '',
      configList: {},
      parent_id: 0,
      columnId: '',
      article: [],
      banner: [],
      imgs: [],
      otherSettings: [],
      settings: [],
      videos: [],
      articleSel: [],
      bannerSel: [],
      imgsSel: [],
      otherSettingsSel: [],
      settingsSel: [],
      videosSel: [],
      articleSelected: [],
      bannerSelected: [],
      imgsSelected: [],
      otherSettingsSelected: [],
      settingsSelected: [],
      videosSelected: [],
      tags: [],
      defaultArray: [],
      configArray: [],
      addArray: [],
      deleteArray: [],
      nav: '',
    };
  },
  async mounted() {
    // 获取未进行编辑的栏目
    await this.getConfigs();
  },
  computed: {

  },
  components: { navigation },

  methods: {
    getConfigs() {
      axios.get(`${api.url}getConfigList`, { params: { wid: this.$store.state.websiteId } }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          const content = data.content;
          this.tid = content.tid;
          if (content.article.length > 0) {
            this.article = content.article;
          }
          if (content.banner.length > 0) {
            this.banner = content.banner;
          }
          if (content.imgs.length > 0) {
            this.imgs = content.imgs;
          }
          if (content.otherSettings.length > 0) {
            this.otherSettings = content.otherSettings;
          }
          if (content.settings.length > 0) {
            this.settings = content.settings;
          }
          if (content.videos.length > 0) {
            this.videos = content.videos;
          }
          if (this.$store.state.columnId) {
            this.columnId = this.$store.state.columnId;
            this.getDetail(this.$store.state.columnId);
          }
        }
      })
        .catch(() => { });
    },
    getDetail(id) {
      axios.get(`${api.url}getColumnDetail`, { params: { id, wid: this.$store.state.websiteId } }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          const configList = data.configList;
          this.defaultArray = [...configList.article, ...configList.imgs, ...configList.videos, ...configList.banner, ...configList.settings, ...configList.otherSettings];
          this.tags = [...configList.article, ...configList.imgs, ...configList.videos, ...configList.banner, ...configList.settings, ...configList.otherSettings];
          this.name = data.content.name;
          for (let i = 0; i < configList.article.length; i += 1) {
            this.articleSelected.push(configList.article[i].name);
            this.article.push(configList.article[i]);
            this.articleSel.push(configList.article[i]);
          }
          for (let i = 0; i < configList.imgs.length; i += 1) {
            this.imgsSelected.push(configList.imgs[i].name);
            this.imgs.push(configList.imgs[i]);
            this.imgsSel.push(configList.imgs[i]);
          }
          for (let i = 0; i < configList.videos.length; i += 1) {
            this.videosSelected.push(configList.videos[i].name);
            this.videos.push(configList.videos[i]);
            this.videosSel.push(configList.videos[i]);
          }
          for (let i = 0; i < configList.banner.length; i += 1) {
            this.bannerSelected.push(configList.banner[i].name);
            this.banner.push(configList.banner[i]);
            this.bannerSel.push(configList.banner[i]);
          }
          for (let i = 0; i < configList.settings.length; i += 1) {
            this.settingsSelected.push(configList.settings[i].name);
            this.settings.push(configList.settings[i]);
            this.settingsSel.push(configList.settings[i]);
          }
          for (let i = 0; i < configList.otherSettings.length; i += 1) {
            this.otherSettingsSelected.push(configList.otherSettings[i].name);
            this.otherSettings.push(configList.otherSettings[i]);
            this.otherSettingsSel.push(configList.otherSettings[i]);
          }
        }
      })
        .catch(() => {
        });
    },
    selectArticle(arr) {
      this.articleSel = api.selectMul(this.article, arr, 'article');
      this.tags = [...this.articleSel, ...this.imgsSel, ...this.videosSel, ...this.bannerSel, ...this.settingsSel, ...this.otherSettingsSel];
    },
    back() {
      this.$router.back(-1);
    },
    selectImgs(arr) {
      this.imgsSel = api.selectMul(this.imgs, arr, 'imgs');
      this.tags = [...this.articleSel, ...this.imgsSel, ...this.videosSel, ...this.bannerSel, ...this.settingsSel, ...this.otherSettingsSel];
    },
    selectVideos(arr) {
      this.videosSel = api.selectMul(this.videos, arr, 'videos');
      this.tags = [...this.articleSel, ...this.imgsSel, ...this.videosSel, ...this.bannerSel, ...this.settingsSel, ...this.otherSettingsSel];
    },
    selectBanner(arr) {
      this.bannerSel = api.selectMul(this.banner, arr, 'banner');
      this.tags = [...this.articleSel, ...this.imgsSel, ...this.videosSel, ...this.bannerSel, ...this.settingsSel, ...this.otherSettingsSel];
    },
    selectSettings(arr) {
      this.settingsSel = api.selectMul(this.settings, arr, 'settings');
      this.tags = [...this.articleSel, ...this.imgsSel, ...this.videosSel, ...this.bannerSel, ...this.settingsSel, ...this.otherSettingsSel];
    },
    selectOtherSettings(arr) {
      this.otherSettingsSel = api.selectMul(this.otherSettings, arr, 'otherSettings');
      this.tags = [...this.articleSel, ...this.imgsSel, ...this.videosSel, ...this.bannerSel, ...this.settingsSel, ...this.otherSettingsSel];
    },
    _handleClose(tag) {
      switch (tag.type) {
        case 'article':
          this.articleSelected.splice(this.articleSelected.indexOf(tag.name), 1);
          this.articleSel.splice(this.articleSel.indexOf(tag), 1);
          break;
        case 'imgs':
          this.imgsSelected.splice(this.imgsSelected.indexOf(tag.name), 1);
          this.imgsSel.splice(this.imgsSel.indexOf(tag), 1);
          break;
        case 'videos':
          this.videosSelected.splice(this.videosSelected.indexOf(tag.name), 1);
          this.videosSel.splice(this.videosSel.indexOf(tag), 1);
          break;
        case 'banner':
          this.bannerSelected.splice(this.bannerSelected.indexOf(tag.name), 1);
          this.bannerSel.splice(this.bannerSel.indexOf(tag), 1);
          break;
        case 'settings':
          this.settingsSelected.splice(this.settingsSelected.indexOf(tag.name), 1);
          this.settingsSel.splice(this.settingsSel.indexOf(tag), 1);
          break;
        case 'otherSettings':
          this.otherSettingsSelected.splice(this.otherSettingsSelected.indexOf(tag.name), 1);
          this.otherSettingsSel.splice(this.otherSettingsSel.indexOf(tag), 1);
          break;
        default:
          break;
      }
      this.tags = [...this.articleSel, ...this.imgsSel, ...this.videosSel, ...this.bannerSel, ...this.settingsSel, ...this.otherSettingsSel];
    },
    addArt() {
      const _ = this;
      // 英文和数字组合判断的正则表达式
      if (this.name === '') {
        this.$message({
          message: '请填写栏目名称',
          type: 'warning',
        });
        return;
      }
      // 进行编辑时才可能删除掉已保存的配置项
      if (this.$store.state.columnId) {
        this.deleteArray = this.defaultArray.filter(item => !_.tags.includes(item));
        this.addArray = this.tags.filter(item => !_.defaultArray.includes(item));
      }
      const data = {
        wid: this.$store.state.websiteId,
        columnId: this.columnId,
        name: this.name,
        configArray: this.tags,
        addArray: this.addArray,
        deleteArray: this.deleteArray,
        tid: this.tid,
      };
      axios.post(`${api.url}addColumn`, data).then((response) => {
        if (response.data.ret === 0) {
          this.$alert('操作成功~', '', {
            confirmButtonText: '确定',
            callback: () => {
              window.history.back();
            },
          });
        } else if (response.data.ret === 1) {
          this.$message({
            message: response.data.msg,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/columnConfig/addColumn.vue